module.exports = __webpack_public_path__ + "static/media/letra_blanca.53903d18.png";